import { z } from 'zod';

/** Aliases of event names and attribute keys (BB-29, DEC-021): an old spelling rewritten to its canonical name. */
export const AliasKind = z.enum(['event', 'attribute']);
export type AliasKind = z.infer<typeof AliasKind>;

export const AliasListQuery = z.object({ kind: AliasKind.optional(), canonical: z.string().max(255).optional() });

export const CreateAliasBody = z.strictObject({
  kind: AliasKind,
  aliasName: z.string().min(1).max(255),
  canonicalName: z.string().min(1).max(255),
  note: z.string().max(500).optional(),
  /** Rewrites data already stored under the alias (job `catalog.alias-backfill`). */
  migrateExisting: z.boolean().default(false),
});
export type CreateAliasBody = z.infer<typeof CreateAliasBody>;

export const AliasUsageQuery = z.object({ days: z.coerce.number().int().min(1).max(90).default(30), kind: AliasKind.optional() });
